import { paramsToQueryKey } from '@/shared/lib/react-query';

const PREFIX = 'order-settings';

export const OrderSettingsQueryKeys = {
  columns: (documentType: string) => paramsToQueryKey([PREFIX], { documentType, type: 'columns' }),
  settings: (documentType: string, distributorId: number) =>
    paramsToQueryKey([PREFIX], { documentType, distributorId, type: 'settings' }),
};
